export { CampaignParser } from './attribution/campaign-parser';
export { CampaignTracker } from './attribution/campaign-tracker';
export { isNewCampaign, isExcludedReferrer, createCampaignEvent, getDefaultExcludedReferrers, } from './attribution/helpers';
export { WebAttribution } from './attribution/web-attribution';
export { BASE_CAMPAIGN } from './attribution/constants';
export { getQueryParams } from './query-params';
export { isNewSession } from './session';
export { getCookieName, getOldCookieName } from './cookie-name';
export { getStorageKey } from './storage/helpers';
export { CookieStorage } from './storage/cookie';
export { FetchTransport } from './transports/fetch';
export { getAnalyticsConnector, setConnectorDeviceId, setConnectorUserId } from './analytics-connector';
export { IdentityEventSender } from './plugins/identity';
export { getLanguage } from './language';
export { getGlobalScope } from './global-scope';
export { getPageViewTrackingConfig, getAttributionTrackingConfig, isAttributionTrackingEnabled, isFileDownloadTrackingEnabled, isFormInteractionTrackingEnabled, isPageViewTrackingEnabled, isSessionTrackingEnabled, } from './default-tracking';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-client-common/lib/esm/index.js
// module id = 38
// module chunks = 1